import RecurringTransactionDetails from "./RecurringTransactionDetails";
import EditRowTransactions from "./EditRowTransactions";
import EmissionsVolumeForm from "../../inputs/emissions/EmissionsVolumeForm";

const ViewRowTransactionDetails = ({
  transaction,
  setIsSlideOpen,
  ...otherProps
}) => {
  const { type, source } = transaction;

  if (source === "manual-emission") {
    return (
      <EmissionsVolumeForm
        existingEmission={transaction}
        setDialogOpen={setIsSlideOpen}
      />
    );
  }

  if (source === "recurring-closed") {
    return (
      <RecurringTransactionDetails
        transaction={transaction}
        setIsSlideOpen={setIsSlideOpen}
        {...otherProps}
      />
    );
  }

  //TODO: FOR PBR-230, we'll want to add in a conditional to display EditRowTransactions for default-utilities emissions
  if (type === "transaction") {
    return (
      <EditRowTransactions
        transaction={transaction}
        setIsSlideOpen={setIsSlideOpen}
        {...otherProps}
      />
    );
  }

  return (
    <RecurringTransactionDetails
      transaction={transaction}
      setIsSlideOpen={setIsSlideOpen}
      {...otherProps}
    />
  );
};
export default ViewRowTransactionDetails;
